// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"9eefde92","239":"ae1c7a0b","338":"81a8f243","453":"aaf14b37","732":"1dd47ecc","749":"84b2ee8d","861":"807dad9c"}[chunkId] + ".chunk.js";
};